import { IWidgetCard } from '@entities/widget-card/model/types';
import { useLightBoxControl } from '@shared/ui';

export const useDetailsLightBox = ({
    displayedWidgetCardData,
    slides,
}: {
    displayedWidgetCardData: IWidgetCard;
    slides: { id: string; image: string }[];
}) => {
    const { onCloseLightBox, onShowLightBox, files, currentFileId, currentFile } =
        useLightBoxControl();

    const displayedSlides =
        displayedWidgetCardData?.fullDescriptionData?.attachedImages?.map((image, index) => ({
            id: index,
            image: image.url,
        })) ?? slides;
    const lightBoxFiles =
        displayedWidgetCardData?.fullDescriptionData?.attachedImages?.map((image, index) => ({
            id: index,
            fileSrc: image.url,
            mimeType: 'image',
        })) ?? [];

    return {
        displayedSlides,
        lightBoxFiles,
        onCloseLightBox,
        onShowLightBox,
        files,
        currentFileId,
        currentFile,
    };
};
